// extracted by mini-css-extract-plugin
export default {"recos":"O5-z","productCardOverride":"P5-z","rowHasBadge":"Q5-z"};